import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { ref, watch, nextTick, onBeforeUnmount } from "vue";
import AiCustomizationPanel from "./AiCustomizationPanel.vue";

const PANEL_WIDTH = 395;


export default /*@__PURE__*/_defineComponent({
  __name: 'AiRefinePopover',
  props: {
    show: { type: Boolean },
    triggerEl: {},
    disabled: { type: Boolean },
    title: { default: "AI Refine" },
    generateButtonLabel: { default: "Generate Message" },
    showAttachments: { type: Boolean, default: true }
  },
  emits: ["generate", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const panelRef = ref<HTMLElement | null>(null);
const panelStyle = ref<Record<string, string>>({
  position: "fixed",
  zIndex: "11000",
  width: `${PANEL_WIDTH}px`,
  visibility: "hidden",
});
const arrowStyle = ref<Record<string, string>>({});

function updatePosition() {
  if (!props.triggerEl || !panelRef.value) return;

  const triggerRect = props.triggerEl.getBoundingClientRect();
  // Use offsetHeight for accurate rendered height after paint
  const panelHeight = panelRef.value.offsetHeight || 360;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const gap = 8;

  const spaceBelow = vh - triggerRect.bottom;
  const spaceAbove = triggerRect.top;
  const showAbove = spaceAbove > spaceBelow && spaceAbove >= panelHeight + gap;

  const top = showAbove ? triggerRect.top - panelHeight - gap : triggerRect.bottom + gap;

  // Center the panel on the trigger button, clamped to viewport
  let left = triggerRect.left + triggerRect.width / 2 - PANEL_WIDTH / 2;
  left = Math.max(8, Math.min(left, vw - PANEL_WIDTH - 8));

  const arrowLeft = triggerRect.left + triggerRect.width / 2 - left - 8;

  panelStyle.value = {
    position: "fixed",
    top: `${top}px`,
    left: `${left}px`,
    zIndex: "11000",
    width: `${PANEL_WIDTH}px`,
    visibility: "visible",
  };

  arrowStyle.value = {
    left: `${Math.max(8, Math.min(arrowLeft, PANEL_WIDTH - 24))}px`,
    ...(showAbove
      ? { top: "100%", borderTopColor: "#e8e8f0", borderBottomColor: "transparent" }
      : { top: "-8px", borderBottomColor: "#e8e8f0", borderTopColor: "transparent" }),
  };
}

watch(
  () => props.show,
  async (val) => {
    if (val) {
      // Reset to hidden so panel renders off-screen before we measure
      panelStyle.value = {
        position: "fixed",
        zIndex: "11000",
        width: `${PANEL_WIDTH}px`,
        visibility: "hidden",
        top: "-9999px",
        left: "-9999px",
      };
      await nextTick();
      // requestAnimationFrame ensures the browser has painted and offsetHeight is accurate
      requestAnimationFrame(() => {
        updatePosition();
      });
      window.addEventListener("scroll", updatePosition, true);
      window.addEventListener("resize", updatePosition);
    } else {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    }
  }
);

onBeforeUnmount(() => {
  window.removeEventListener("scroll", updatePosition, true);
  window.removeEventListener("resize", updatePosition);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "panelRef",
          ref: panelRef,
          class: "ai-refine-popover",
          style: _normalizeStyle(panelStyle.value)
        }, [
          _createElementVNode("div", {
            class: "ai-refine-popover__arrow",
            style: _normalizeStyle(arrowStyle.value)
          }, null, 4),
          _createVNode(AiCustomizationPanel, {
            disabled: __props.disabled,
            "show-close": true,
            title: __props.title,
            "generate-button-label": __props.generateButtonLabel,
            "show-attachments": __props.showAttachments,
            onGenerate: _cache[0] || (_cache[0] = ($event: any) => (emit('generate', $event))),
            onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
          }, null, 8, ["disabled", "title", "generate-button-label", "show-attachments"])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})